export const AMAZON_MIN_DAILY_VOLUME = 1500;
export const UNIUNI_MIN_DAILY_VOLUME = 400;
